// Apartament duplex - Bucuresti, Sector 2, Str. Rascoala 1907 nr. 9B (etajele 8 si 9)
// Route: /new-residences-colentina (also served at /)
//
// Suprafetele provin din planul cadastral (Ap. 801): util 68,2 mp, terasa 65,2 mp,
// total 141,6 mp.

import img01 from '../media/colentina/01-living-vedere.jpg';
import img02 from '../media/colentina/02-living-acces-balcon.jpg';
import img03 from '../media/colentina/03-dormitor-vedere-stadion.jpg';
import img04 from '../media/colentina/04-dormitor.jpg';
import img05 from '../media/colentina/05-dormitor-acces-hol.jpg';
import img06 from '../media/colentina/06-spatiu-deschis-vedere.jpg';
import img07 from '../media/colentina/07-baie-cabina-dus.jpg';
import img08 from '../media/colentina/08-baie.jpg';
import img09 from '../media/colentina/09-scara-interioara.jpg';
import img10 from '../media/colentina/10-hol-intrare-scara.jpg';
import img11 from '../media/colentina/11-palier-scara.jpg';
import img12 from '../media/colentina/12-palier-fereastra.jpg';
import img13 from '../media/colentina/13-hol.jpg';
import img14 from '../media/colentina/14-camera-tehnica-centrala.jpg';
import img15 from '../media/colentina/15-camera-tehnica-distribuitor.jpg';
import img16 from '../media/colentina/16-terasa-panorama.jpg';
import img17 from '../media/colentina/17-terasa.jpg';
import img18 from '../media/colentina/18-terasa-vedere.jpg';
import img19 from '../media/colentina/19-terasa-pergola.jpg';
import img20 from '../media/colentina/20-terasa-pergola-vedere.jpg';
import img21 from '../media/colentina/21-terasa-zona-umbrita.jpg';
import img22 from '../media/colentina/22-terasa-zona-acoperita.jpg';
import img23 from '../media/colentina/23-terasa-acces-interior.jpg';
import img24 from '../media/colentina/24-terasa-prize.jpg';
import img25 from '../media/colentina/25-terasa-racord-apa.jpg';
import img26 from '../media/colentina/26-hol-intrare-bloc.jpg';
import img27 from '../media/colentina/27-hol-intrare-cutii-postale.jpg';
import img28 from '../media/colentina/28-hol-lifturi-etaj-8.jpg';
import img29 from '../media/colentina/29-hol-acces-apartament.jpg';
import img30 from '../media/colentina/30-parcare.jpg';
import img31 from '../media/colentina/31-parcare-loc.jpg';
import img32 from '../media/colentina/32-exterior-bloc.jpg';
import floorPlan from '../media/colentina/plan-apartament.jpg';

// Randari 3D din proiectul de design interior comandat inainte de vanzare.
// Nu sunt fotografii ale apartamentului in starea actuala.
import d01 from '../media/colentina/design/01-hol-intrare.jpg';
import d02 from '../media/colentina/design/02-hol-oglinda.jpg';
import d03 from '../media/colentina/design/03-hol-scara.jpg';
import d04 from '../media/colentina/design/04-hol-bancheta.jpg';
import d05 from '../media/colentina/design/05-scara-detaliu.jpg';
import d06 from '../media/colentina/design/06-palier-superior.jpg';
import d07 from '../media/colentina/design/07-hol-dressing.jpg';
import d08 from '../media/colentina/design/08-living.jpg';
import d09 from '../media/colentina/design/09-living-canapea.jpg';
import d10 from '../media/colentina/design/10-living-dining.jpg';
import d11 from '../media/colentina/design/11-living-tv.jpg';
import d12 from '../media/colentina/design/12-living-tv-dining.jpg';
import d13 from '../media/colentina/design/13-living-tablou.jpg';
import d14 from '../media/colentina/design/14-dining.jpg';
import d15 from '../media/colentina/design/15-bucatarie.jpg';
import d16 from '../media/colentina/design/16-bucatarie-plita.jpg';
import d17 from '../media/colentina/design/17-bucatarie-chiuveta.jpg';
import d18 from '../media/colentina/design/18-bucatarie-ansamblu.jpg';
import d19 from '../media/colentina/design/19-dormitor-matrimonial.jpg';
import d20 from '../media/colentina/design/20-dormitor-matrimonial-toaleta.jpg';
import d21 from '../media/colentina/design/21-dormitor-matrimonial-dulapuri.jpg';
import d22 from '../media/colentina/design/22-dormitor-tv.jpg';
import d23 from '../media/colentina/design/23-dormitor-tv-frontal.jpg';
import d24 from '../media/colentina/design/24-dormitor-detaliu.jpg';
import d25 from '../media/colentina/design/25-dormitor-birou.jpg';
import d26 from '../media/colentina/design/26-dormitor-birou-detaliu.jpg';
import d27 from '../media/colentina/design/27-dormitor-doi.jpg';
import d28 from '../media/colentina/design/28-dormitor-doi-frontal.jpg';
import d29 from '../media/colentina/design/29-baie.jpg';
import d30 from '../media/colentina/design/30-baie-dus.jpg';
import d31 from '../media/colentina/design/31-grup-sanitar.jpg';
import d32 from '../media/colentina/design/32-grup-sanitar-lavoar.jpg';

const designImages = [
  d01, d02, d03, d04, d05, d06,
  d07, d08, d09, d10, d11, d12,
  d13, d14, d15, d16, d17, d18,
  d19, d20, d21, d22, d23, d24,
  d25, d26, d27, d28, d29, d30,
  d31, d32,
];

const colentina = {
  id: 'colentina',
  path: '/new-residences-colentina',
  documentTitle: 'Apartament duplex 3 camere cu terasă 65 mp - București, Colentina',
  metaDescription:
    'Apartament duplex 3 camere de vânzare în București, Sector 2, Str. Răscoala 1907, Nr. 9B - etajele 8 și 9, terasă 65,2 mp, loc de parcare inclus, bloc din 2022 | Comision 0% pentru cumpărător',

  // Sale is handled by an agency under contract with the owner. The agency's
  // commission is paid by the owner, so the buyer still pays none. No price or
  // phone number is published for this listing.
  topBarNotes: [{ icon: '✓', text: 'Comision 0% pentru cumpărător', highlight: true }],

  badge: 'De Vânzare',
  title: 'Apartament duplex în București',
  subtitle: 'Sector 2, Str. Răscoala 1907, Nr. 9B — etajele 8 și 9',

  gallery: [
    img01, img02, img03, img04, img05, img06, img07, img08, img09, img10,
    img11, img12, img13, img14, img15, img16, img17, img18, img19, img20,
    img21, img22, img23, img24, img25, img26, img27, img28, img29, img30,
    img31, img32,
  ],
  heroImage: img16,

  infoItems: [
    { icon: '🛏️', text: '3 Camere' },
    { icon: '📐', text: '68,2 mp utili' },
    { icon: '🌇', text: 'Terasă 65,2 mp' },
    { icon: '🏢', text: 'Etajele 8 și 9' },
    { icon: '📍', text: 'București, Sector 2' },
    { icon: '🅿️', text: 'Parcare inclusă' },
  ],

  floorPlan: {
    image: floorPlan,
    heading: 'Plan Apartament',
    description: 'Etajul 8 (locuință) și etajul 9 (terasă), cu suprafețele din cadastru',
  },

  designProject: {
    heading: 'Proiect de Amenajare',
    description:
      'Randări 3D dintr-un proiect de design interior realizat pentru acest apartament',
    note:
      'Acestea sunt randări 3D, nu fotografii ale apartamentului în starea actuală. Proiectul complet de amenajare poate fi predat cumpărătorului interesat.',
    images: designImages,
  },

  features: [
    { icon: '🏠', title: 'Tip Apartament', text: 'Duplex, 3 camere (2 dormitoare și living)' },
    { icon: '📐', title: 'Suprafață Utilă', text: '68,2 mp' },
    { icon: '📏', title: 'Suprafață Totală', text: '141,6 mp (cu terasa)' },
    { icon: '🌇', title: 'Terasă', text: '65,2 mp, la etajul 9' },
    { icon: '🏢', title: 'Etaj', text: 'Etajele 8 și 9, cu scară interioară' },
    { icon: '🚿', title: 'Băi', text: 'O baie și un grup sanitar de serviciu' },
    { icon: '🔥', title: 'Încălzire', text: 'Centrală proprie pe gaz' },
    { icon: '📅', title: 'An Construcție', text: '2022' },
    {
      icon: '🎨',
      title: 'Proiect de Amenajare',
      text: 'Realizat de designer, se predă cumpărătorului interesat',
    },
    {
      icon: '🅿️',
      title: 'Loc de Parcare',
      text: 'Inclus în preț, la parter înălțat — fără risc de inundare',
    },
    { icon: '🛗', title: 'Lifturi', text: 'Două lifturi' },
    { icon: '📍', title: 'Zonă', text: 'Colentina, Sector 2, București' },
  ],

  location: {
    summary: 'București, Sector 2, Str. Răscoala 1907, Nr. 9B',
    addressLines: [
      'Str. Răscoala 1907, Nr. 9B',
      'Etajele 8 și 9 (duplex)',
      'Sector 2, București',
      'România',
    ],
    // Embed generated by Google Maps for the "NEW Residences Colentina" place
    // itself, so the pin sits on the building rather than a geocoded address.
    mapEmbedSrc:
      'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d535.5740378267232!2d26.14253286973402!3d44.465740693354206!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40b1f94626a95b91%3A0x2dae65a274611672!2sNEW%20Residences%20Colentina!5e1!3m2!1sen!2sch!4v1788961493848!5m2!1sen!2sch',
  },

  footerText:
    'Apartament duplex de vânzare • București, Sector 2, Str. Răscoala 1907',
};

export default colentina;
